import { useState } from "react"

export const AddTask = () => {

    const[taskValue, setTaskValue] = useState("");
    const[progress, setProgress] = useState(false);

    const handleChange = (e) => {
        setTaskValue(e.target.value)
    }

    const handleReset = (event) => {
        setTaskValue("");
        setProgress(false);
    }

    const handleSubmit =(event) => {
        event.preventDefault();
        const task ={
            id: Math.floor(Math.random()*10000),
            name: taskValue,
            completed: Boolean(progress)
        }
        console.log(task);
        handleReset();
    }

    return (
        <>
        <section className="addtask">
            <form onSubmit={handleSubmit}>
                <input onChange={handleChange} type="text" name ="task" id="task" placeholder="Task Name" autoComplete="off" value={taskValue} required/>
                <select onChange={(e)=> setProgress(e.target.value)} value={progress}>
                    <option value="true">Completed</option>
                    <option value="false">Pending</option>
                </select>
                <button type="submit">Add Task</button>
                <button onClick={handleReset} className="reset" type="reset">Reset</button>
            </form>
            <p>{taskValue}</p>
        </section>
        </>
    )
    }
